import classNames from "classnames";
import React, { FC } from "react";

import { useScreenMd } from "~/utils";

export const ChatNotifications: FC = () => {
  const isDesktop = useScreenMd();
  return (
    <div className="h-95 flex flex-col justify-between relative">
      <div
        className={classNames(
          "flex flex-col gap-md mg-0-auto h-95",
          isDesktop ? "w-80" : "w-90"
        )}
      >
        Chat notifications
      </div>
    </div>
  );
};
